import { Base, Component, Inject } from '@/vue-property-decorator'
import { VerticalProps } from '../../components/basePropsConfig'
import style from './style.module.scss'
/** 游戏名称上下结构 */
@Component<GamePlatformName>({
  name: 'GamePlatformName'
})
export default class GamePlatformName extends Base {
  @Inject() cardProps!: Required<VerticalProps>

  /** 渲染游戏名称 */
  render() {
    const { inCardRenderCategory, gameName } = this.cardProps
    return (
      <div
        class={{
          ['game-platform-name']: true,
          [style['game-platform-name']]: true,
          [style[`type-${inCardRenderCategory}`]]: true
        }}
      >
        <div class={style['name-inner']}>{gameName}</div>
      </div>
    )
  }
}
